import { createEndpoint } from '@/shared/models/api';
import { UserInformation } from '@/app/api/morgan-thermal/user';

export const getUser = createEndpoint<UserInformation>(({fetch}) => (userId: UserInformation['id']) => fetch(`/User/${userId}`));